export default {
  getDetailGeneral: ({ details }) => details.general,
  isDetailsEditableBlock: ({ details }) => blockName => details.editableBlock === blockName,
  getDetailsEditableBlock: ({ details }) => details.editableBlock,
};
